import { templateFieldsTccOnboarding } from './template-fields1';
import { templateFieldsCsTicket } from './template-fields3';
import { templateFieldsCsTicketCovid } from './template-fields4';

export const templateFields = {
    1: templateFieldsTccOnboarding,
    3: templateFieldsCsTicket,
    4: templateFieldsCsTicketCovid
};
